



























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from "vue-typedi";
import {AlertSettings} from "@/model/AlertSettings";
import {AlertChannel, AlertService, AlertSettingsRequest} from "@/services/AlertService";
import AlertSubscriptionButton from "@/components/alert/AlertSubscriptionButton.vue";
import AlertList from "@/components/alert/AlertList.vue";
import AlertForm from "@/components/alert/AlertForm.vue";
import AlertDeleteForm from "@/components/alert/AlertDeleteForm.vue";
import {EventBus} from "@/helpers/EventBus";
import { Zone } from '@/model/Zone';
import ZonePicto from '@/components/ZonePicto.vue';

@Component({
  components: {AlertList, AlertForm, AlertDeleteForm, AlertSubscriptionButton, ZonePicto}
})
export default class AlertDashBoard extends Vue {

    private static readonly ERROR_DURATION_MS: number = 1000 * 3;

    @Prop({default: {}}) zone: Zone;

    @Inject()
    alertService!: AlertService;

    public alertSettings: AlertSettings = new AlertSettings;

    public deleteEmail: string = "";

    public isDisplayed: boolean = false;
    public hasSubscriptionError: boolean = false;

    get storeId(): string {
        return sessionStorage.getItem("storeId");
    }

    public deleteForm() {
        return this.deleteEmail != null && this.deleteEmail != "";
    }

    public hasEmail() {
        return this.alertSettings != null && this.alertSettings.emails != null && this.alertSettings.emails.length > 0;
    }

    public hideDeleteForm() {
        this.deleteEmail = "";
    }

    created() {
        this.alertService.getAlerts(this.storeId, this.zone.zoneCode).then(data => {
            this.alertSettings = data;
        });

        EventBus.$on(EventBus.REFRESH_ALERT_SETTINGS, this.onRefreshAlertSettings);
        EventBus.$on(EventBus.SHOW_DELETE_EMAIL_FORM, this.onShowDeleteEmailForm);
    }

    beforeDestroy() {
        EventBus.$off(EventBus.REFRESH_ALERT_SETTINGS, this.onRefreshAlertSettings);
        EventBus.$off(EventBus.SHOW_DELETE_EMAIL_FORM, this.onShowDeleteEmailForm);
    }

    private onRefreshAlertSettings(alertSettings: AlertSettings) {
        if (alertSettings.zoneCode == this.zone.zoneCode) {
                this.alertSettings = alertSettings;
                this.hideDeleteForm();
        }
    }

    private onShowDeleteEmailForm(data: {email: string, zoneCode: string}) {
        if (data.zoneCode == this.zone.zoneCode) {
            this.deleteEmail = data.email;
        }
    }

    get zoneCode(): string {
        if (this.zone == null || this.zone == undefined) {
            return null;
        }

        return this.zone.zoneCode;
    }

    get zoneLabel(): string {
        if (this.zone == null || this.zone == undefined) {
            return null;
        }

        return this.zone.zoneLabel;
    }

    get isSubscriptionActive(): boolean {
        if (!this.alertSettings || !this.alertSettings.devices) {
            return false;
        }

        const deviceRegistrationId = this.alertService.getDeviceRegistrationId();
        return deviceRegistrationId && this.alertSettings.devices.includes(deviceRegistrationId);
    }

    onToggleSubscription() {
        const deviceRegistrationId = this.alertService.getDeviceRegistrationId();
        
        const request = {
            identifier: deviceRegistrationId,
            channel: AlertChannel.NOTIFICATION_ON_DEVICE,
            storeId: this.storeId,
            zoneCode: this.zone.zoneCode
        } as AlertSettingsRequest;

        const action = this.isSubscriptionActive
                    ? (req: AlertSettingsRequest) => this.alertService.deleteAlert(req)
                    : (req: AlertSettingsRequest) => this.alertService.insertAlert(req);
        action(request)
            .then(alertSettings => {
                EventBus.$emit(EventBus.REFRESH_ALERT_SETTINGS, alertSettings);
            }).catch((error) => {
                this.hasSubscriptionError = true;
                setTimeout(() => { this.hasSubscriptionError = false }, AlertDashBoard.ERROR_DURATION_MS);
            });
    }
}
